import { yupResolver } from '@hookform/resolvers/yup';
import cn from 'classnames';
import Image from 'next/image';
import { ReactNode, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Container, Feedback } from '../../components';
import { IFormContact } from '../../components/form-contact';
import { useModal } from '../../hooks';
import { sendMessage } from '../../services/contact.service';
import { subscribeSchema } from '../../validation/submit.schema';
import TextField from '../linkapp/text-field';
import TextMask from '../linkapp/text-mask';
import styles from './design-contact.module.css';

export interface DesignContactProps {
  title: ReactNode;
}

export default function DesignContact({ title }: DesignContactProps) {
  const { setContent, open } = useModal();
  const [disabled, setDisabled] = useState<boolean>(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<IFormContact>({
    mode: 'onBlur',
    resolver: yupResolver(subscribeSchema),
  });

  const onSubmit = async (data: IFormContact) => {
    setDisabled(true);
    const response = await sendMessage(data);

    if (String(response.status).startsWith('2')) {
      setDisabled(false);
      setContent(<Feedback />);
      open();
      reset();
    }
  };

  return (
    <div className={styles.root}>
      <Container>
        <div className={styles.form_box} id="form">
          {title}
          <p className={styles.form_subtitle}>
            Leave us a message and we will reach out to you
          </p>
        </div>
        <div className={styles.form_inner}>
          <form
            className={cn(styles.form_start, {
              [styles.disabled]: disabled,
            })}
          >
            <TextField
              className={styles.form_input}
              helper="Name"
              error={!!errors?.name}
              message={errors?.name?.message}
              placeholder="Your Name"
              {...register('name')}
            />

            <TextField
              className={styles.form_input}
              {...register('email')}
              error={!!errors?.email}
              helper="Email"
              message={errors?.email?.message}
              placeholder="Your Email"
            />

            <TextMask
              className={styles.form_input}
              label="Phone"
              placeholder="Your number"
              {...register('phone')}
              mask="+9999999999999"
            />

            <TextField
              className={styles.form_input}
              {...register('message')}
              helper="Message"
              placeholder="Text Message"
              error={!!errors?.message}
              message={errors?.message?.message}
            />
            <div className={styles.button}>
              <Button
                appearance="design"
                type="submit"
                disabled={disabled}
                onClick={handleSubmit(onSubmit)}
              >
                Send
              </Button>
            </div>
          </form>
          <div className={styles.form_end}>
            <Image
              src="/design/ship-min.png"
              alt="starship picture"
              width={873}
              height={825}
            />
          </div>
        </div>
      </Container>
    </div>
  );
}
